import {times} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import 'stylesheets/components/shared-step.scss';

function Step(props) {
  const className = classNames('shared-step', {active: props.active});
  return <span className={className} />;
}

Step.propTypes = {
  active: PropTypes.bool,
};

function Steps(props) {
  return (
    <div data-testid={`step-${props.currentStepIndex}-out-of-${props.numberOfSteps}-steps`}>
      {times(props.numberOfSteps, (step) => (
        <Step key={step} active={step === props.currentStepIndex} />
      ))}
    </div>
  );
}

Steps.propTypes = {
  numberOfSteps: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
};

export default Steps;
